class RelatedProductsSlider extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.slider || !this.sliderItemsToShow?.length) return;

    this.initPages();
    if (!this.sliderItemOffset) return;

    const lastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    const atEnd = this.isSlideVisible(lastItem);
    const atStart = this.slider.scrollLeft <= 1;

    if (event.currentTarget.name === 'next' && atEnd) {
      this.slider.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }

    if (event.currentTarget.name === 'previous' && atStart) {
      this.slider.scrollTo({
        left: this.slider.scrollWidth - this.slider.clientWidth,
        behavior: 'smooth',
      });
      return;
    }

    const step = Number(event.currentTarget.dataset.step) || 1;
    const offset =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    this.setSlidePosition(offset);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth',
    });
  }
}

customElements.define('related-products-slider', RelatedProductsSlider);
